export default "__VITE_ASSET__DtNlnPdy__"